// extracted by css-extract-rspack-plugin
export default {"list":"_96ad87e3"};